<i18n>
{
  "fr": {
    "applicant-first-connection-title": "Vous êtes connecté!",
    "applicant-first-connection-subtitle": "Gestion des utilisateurs",
    "applicant-first-connection-text": "Souhaitez-vous ajouter des utilisateurs dans votre compte entreprise? Vous pourrez également le faire plus tard.",
    "applicant-manage-business-users-btn": "Ajouter des utilisateurs",
    "applicant-go-to-dashboard-btn": "Aller à mon tableau de bord"
  },
  "en": {
    "applicant-first-connection-title": "You are logged in!",
    "applicant-first-connection-subtitle": "Users management",
    "applicant-first-connection-text": "Would you like to add users into your company account? You will also be able to do it later.",
    "applicant-manage-business-users-btn": "Add users",
    "applicant-go-to-dashboard-btn": "Go to my dashboard"
  }
}
</i18n>

<template>
  <welcome>
    <h1 class="title">{{ $t('applicant-first-connection-title') }}</h1>
    <div class="content">
      <p v-if="me" class="is-size-5 has-text-primary">{{ me.email }}</p>
      <h2 class="title is-4">{{ $t('applicant-first-connection-subtitle') }}</h2>
      <p>{{ $t('applicant-first-connection-text') }}</p>
    </div>
    <b-button @click="manageBusinessUsers" type="is-link" class="is-fullwidth mt-24px" outlined>
      {{ $t('applicant-manage-business-users-btn') }}
    </b-button>
    <b-button @click="goToDashboard" type="is-link" class="is-fullwidth mt-24px" outlined>
      {{ $t('applicant-go-to-dashboard-btn') }}
    </b-button>
  </welcome>
</template>

<script>
import BusinessService from '@/services/business'
import Welcome from '@/components/layout/welcome'

import { URL_BUSINESS_DETAIL, URL_USER_DASHBOARD } from '@/consts/urls'

export default {
  components: { Welcome },
  mounted() {
    if (
      this.$router.currentRoute.query.businessId !== undefined &&
      this.$router.currentRoute.query.businessId !== '' &&
      this.$router.currentRoute.query.businessId !== null
    ) {
      BusinessService.setCurrentBusinessData(this.$router.currentRoute.query.businessId)
    }
  },
  methods: {
    manageBusinessUsers: function () {
      this.$router.push({ name: URL_BUSINESS_DETAIL, query: { tab: 'users' } })
    },
    goToDashboard: function () {
      this.$router.push({ name: URL_USER_DASHBOARD })
    }
  },
  apollo: {
    me: {
      query() {
        return this.$options.query.FirstConnection_MyEmail
      }
    }
  }
}
</script>

<graphql>
query FirstConnection_MyEmail {
  me {
    id
    email
  }
}
</graphql>
